module.exports = __webpack_public_path__ + "static/media/227GR.e73f864d.jpg";